import { render } from "./figma5.vue?vue&type=template&id=3e90cc7e&scoped=true"
import script from "./figma5.vue?vue&type=script&lang=js"
export * from "./figma5.vue?vue&type=script&lang=js"

import "./figma5.vue?vue&type=style&index=0&id=3e90cc7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e90cc7e"]])

export default __exports__